export default __webpack_public_path__ + "static/media/DGKchain_logo.28512203.svg";